import React, { useState } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import "./Add.css"; // ✅ new css file
import Moulding from "./Pages/Moulding";
import Upholstery_entry from "./Pages/Upholstery_entry";
import ShippingData from "./ShippingData";

function AddData() {
  const [Mouldings, setMoulding] = useState(false);
  const [Upholsterys, setUpholstery] = useState(false);
  const [shipped, setshipped] = useState(false);
  const [welcome, setwelcome] = useState(true);

  const [Value, setValue] = useState("PO DATA ENTRY");

  const area = (e) => {
    // ✅ FIX: use currentTarget for buttons
    const selected = e.currentTarget.value;

    if (selected === "MOULDING") {
      setMoulding(true);
      setUpholstery(false);
      setshipped(false);
      setwelcome(false);
      setValue("PO DATA ENTRY - MOULDING");
    }

    if (selected === "UPHOLSTERY") {
      setMoulding(false);
      setUpholstery(true);
      setshipped(false);
      setwelcome(false);
      setValue("PO DATA ENTRY - UPHOLSTERY");
    }

    if (selected === "SHIPPING") {
      setMoulding(false);
      setUpholstery(false);
      setshipped(true);
      setwelcome(false);
      setValue("PO DATA ENTRY - SHIPPING DATA");
    }
  };

  return (
    <div className="adddata-page">
      <div className="adddata-topbar">
        <div className="adddata-titlewrap">
          <div className="adddata-kicker">Realform</div>
          <h1 className="adddata-title">{Value}</h1>
        </div>


      </div>

      <div className="adddata-card">
        <div className="adddata-grid">
          <button
            type="button"
            className="adddata-actionBtn"
            value="MOULDING"
            onClick={area}
            title="Enter Moulding PO"
          >
            <div className="adddata-actionTitle">Moulding</div>
            <div className="adddata-actionSub">Enter Moulding PO</div>
          </button>

          <button
            type="button"
            className="adddata-actionBtn"
            value="UPHOLSTERY"
            onClick={area}
            title="Enter Upholstery PO"
          >
            <div className="adddata-actionTitle">Upholstery</div>
            <div className="adddata-actionSub">Upholstery entry</div>
          </button>

          <button
            type="button"
            className="adddata-actionBtn"
            value="SHIPPING"
            onClick={area}
            title="Enter Shipping Data"
          >
            <div className="adddata-actionTitle">Shipping</div>
            <div className="adddata-actionSub">Shipping data entry</div>
          </button>
        </div>
      </div>

      <div className="adddata-content">
        {Mouldings ? <Moulding /> : null}
        {Upholsterys ? <Upholstery_entry /> : null}
        {shipped ? <ShippingData /> : null}
      </div>

      {welcome ? (
        <section className="adddata-welcome">
          <div className="adddata-welcomeInner">
            <div className="adddata-welcomeGlow" />
            <h2 className="adddata-welcomeText">Realform</h2>
            <p className="adddata-welcomeSub">
              Select a department above to start entry.
            </p>
          </div>
        </section>
      ) : null}
    </div>
  );
}

export default AddData;
